define(['morningstar'], function(morningstar) {
    'use strict';

    return {
        toDateObject: toDateObject,
        toDateString: toDateString,
        toUTCDateObject: toUTCDateObject
    };

    // Convert dateString like 20170101 to dateObject after get data form Markets Api 
    function toDateObject(dateString) {
        if (dateString && typeof dateString === 'string') {
            dateString = dateString.trim().replace(/(\/|-)/g, '');
            if (dateString.length >= 8) {
                return new Date(Number(dateString.slice(0, 4)),
                    Number(dateString.slice(4, 6)) - 1,
                    Number(dateString.slice(6, 8)));
            }
        }
        return null;
    }

    // Convert dateOject to dateString format as 20170101 before call Markets Api
    function toDateString(date) {
        if (date && date instanceof Date) {
            var year = date.getFullYear().toString();
            var month = (date.getMonth() + 1).toString();
            if (month.length === 1) {
                month = '0' + month;
            }
            var day = date.getDate().toString();
            if (day.length === 1) {
                day = '0' + day;
            }
            return year + month + day;
        }
        return null;
    }

    // Convert a date created in China timezone(or any other country timezone) to the US timezone where PAAPI resides
    function toUTCDateObject(date) {
        return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    }
});


// WEBPACK FOOTER //
// ./components/multiple-chart/src/js/transforms/date-helper.js